import React, { useState } from "react";
import { uploadLinkAttachmentsProps } from "./customer-view-details-view-attachment-info.props";
import UploadLinkUrlPopup from "../../../../../../common/components/upload-linkUrl-popup/upload-link-url-popup";
import { AlertComponent } from "../../../../../../common/components";
import { addCustomerLinkAttachment } from "../../../../../../api/customer";

const UploadLinkUrlAttachment: React.FC<uploadLinkAttachmentsProps> = ({
  selectedOption,
  setSelectedOption,
  customerId,
  setLoading,
  fetchAttachments,
  customerData,
  setIsEditUrl,
  onClose,
}) => {
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);

  const handleEditUrlClose = () => {
    if (setSelectedOption) setSelectedOption("");
    if (setIsEditUrl) setIsEditUrl(false);
    if (onClose) {
      setTimeout(() => {
        onClose()
      }, 500)
    }
  };

  const handleLinkUpload = async (data: {
    link: string;
    fileName: string;
    attachmentId?: number;
  }) => {
    const payload = { ...data };
    if (customerData?.attachmentId) {
      payload.attachmentId = customerData?.attachmentId;
    }
    try {
      setLoading(true);
      const response = await addCustomerLinkAttachment(customerId, payload);
      if (response?.status === 201) {
        setAlertMessage(`${payload?.attachmentId ? 'Link updated successfully' : 'Link added successfully'}`);
        setAlertType("success");
        fetchAttachments();
        handleEditUrlClose();
      }
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message || error?.response?.data?.error ||
        "Something went wrong. Please try again later."
      );
      setAlertType("error");
    } finally {
      setLoading(false);
      setAlertOpen(true);
    }
  };

  return (
    <>
      {selectedOption === "linkUrl" && (
        <UploadLinkUrlPopup
          open={!!selectedOption}
          title="Attach From Link"
          onCancel={handleEditUrlClose}
          onOkay={handleLinkUpload}
          buttonText="Attach"
          renderEle={<div>Upload file here</div>}
          disable={false}
          leadData={customerData}
        />
      )}
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
    </>
  );
};

export default UploadLinkUrlAttachment;
